import { SwitchProps as SwitchPropsMui } from '@mui/material';
import React from 'react';
import { ColorNeutral300, ColorNeutral600 } from '../../design-system/colors';
import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { Typography } from '../Typography';
import { StyledFormControlLabel, StyledSwitchUi } from './Switch.styles';

const StyledTypography = styled(Typography)`
  margin-left: ${({ theme }) => theme.spacing(Spacing.Tiny)};
`;

export interface SwitchProps
  extends Pick<
    SwitchPropsMui,
    | 'name'
    | 'checked'
    | 'disabled'
    | 'onChange'
    | 'size'
    | 'value'
    | 'disabled'
    | 'defaultChecked'
  > {
  readonly label?: string;
  readonly noMargin?: boolean;
}

export function Switch({
  disabled,
  noMargin = false,
  label,
  value,
  ...props
}: SwitchProps) {
  return (
    <StyledFormControlLabel
      control={
        <StyledSwitchUi
          inputProps={{ 'aria-label': label }}
          type="checkbox"
          {...props}
        />
      }
      disabled={disabled}
      label={
        <StyledTypography
          color={disabled ? ColorNeutral300 : ColorNeutral600}
          variant="body"
        >
          {label}
        </StyledTypography>
      }
      noMargin={noMargin}
      value={value}
    />
  );
}
